module.exports = __webpack_public_path__ + "img/money.d568d4dd.png";